import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'; //component - CoreUI / CSidebarNavTitle

var CSidebarNavTitle = function CSidebarNavTitle(props) {
  var className = props.className,
      innerRef = props.innerRef,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "innerRef"]); //render


  var classes = classNames('c-sidebar-nav-title', className);
  return /*#__PURE__*/React.createElement("li", _extends({
    className: classes
  }, attributes, {
    ref: innerRef
  }));
};

CSidebarNavTitle.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  //
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};
export default CSidebarNavTitle;